const tr = {
  table: {
    emptyDataSource: 'Nenhum registro para exibir',
    loading: 'Carregando...',

    labelRowsPerPage: 'Registros por página',
    backIconButtonText: 'Página anterior',
    nextIconButtonText: 'Próxima página',
    labelDisplayedRows: 'de',
  },
};

export default tr;
